import Add16 from '@carbon/icons-react/es/add/16';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button/button';
import { NewConversationAddMembersModal } from '../add-members-modal';

const Wrapper = styled.div`
  padding: 0;
  .ant-btn svg {
    margin-right: var(--spacing-06);
  }
`;

interface Props {
  conversationName: string;
}

export const NewConversationAddMembersAction: FC<Props> = ({
  conversationName,
}) => {
  const [isVisible, setNewConversationAddMembersModalVisibility] =
    useState(false);

  return (
    <>
      <NewConversationAddMembersModal
        conversationName={conversationName}
        isVisible={isVisible}
        onCancel={() => setNewConversationAddMembersModalVisibility(false)}
      />
      <Wrapper>
        <Button
          size="small"
          type="link"
          icon={<Add16 />}
          iconPlacement="right"
          onClick={() => setNewConversationAddMembersModalVisibility(true)}
        >
          <FormattedMessage id="projects.conversations.members.add_people" />
        </Button>
      </Wrapper>
    </>
  );
};
